import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import themeColorsDesingSystem from "assets/theme/ds-colors";
import {
  formatPeriodo,
  getDisplayImage,
  getVideoEmbedUrl,
  isEmbeddableVideoUrl,
  usesFullBannerImage,
} from "../utils";

const { primary, gray, stone, text } = themeColorsDesingSystem;

export default function PreviewDialog({ item, open, onClose }) {
  if (!item) return null;

  const isVideo = item.tipo === "Video";
  const isFullBanner = usesFullBannerImage(item.tipo);
  const previewImage = getDisplayImage(item);
  const videoSource = item.videoUrl || item.arquivoUrl;
  const videoEmbedUrl = videoSource ? getVideoEmbedUrl(videoSource) : "";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle style={{ color: text.primary }}>
        <Typography
          variant="h4"
          style={{ color: text.primary, fontWeight: 700 }}
        >
          {item.titulo}
        </Typography>
        <IconButton
          onClick={onClose}
          style={{ position: "absolute", right: 8, top: 8 }}
          aria-label="Fechar"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {isVideo && videoSource ? (
          isEmbeddableVideoUrl(videoSource) ? (
            <Box position="relative" paddingTop="56.25%">
              <iframe
                title={item.titulo}
                src={videoEmbedUrl}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: 0,
                  borderRadius: 8,
                }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </Box>
          ) : (
            <video
              src={videoSource}
              controls
              style={{ width: "100%", borderRadius: 8, maxHeight: 480 }}
            />
          )
        ) : isFullBanner && previewImage ? (
          <img
            src={previewImage}
            alt={item.titulo}
            style={{
              width: "100%",
              maxHeight: 560,
              objectFit: "contain",
              borderRadius: 8,
              backgroundColor: stone.light,
            }}
          />
        ) : item.arquivoUrl ? (
          <Box textAlign="center" padding={2}>
            <Button
              variant="contained"
              color="primary"
              component="a"
              href={item.arquivoUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Abrir arquivo
            </Button>
          </Box>
        ) : (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            padding={4}
            style={{
              backgroundColor: stone.light,
              borderRadius: 8,
              minHeight: 320,
            }}
          >
            <PictureAsPdfIcon
              style={{ fontSize: 64, color: primary.main, marginBottom: 16 }}
            />
            <Typography
              variant="body1"
              style={{ color: text.primary, marginBottom: 8 }}
            >
              {item.titulo}
            </Typography>
            <Typography variant="caption" style={{ color: gray.dark }}>
              {item.descricao}
            </Typography>
          </Box>
        )}
        <Box marginTop={2}>
          <Typography variant="caption" style={{ color: gray.dark }}>
            Categoria: {item.categoria} · Vigência:{" "}
            {formatPeriodo(item.dataInicio, item.dataFim)}
          </Typography>
          {item.campanha && (
            <Typography
              variant="caption"
              style={{ color: primary.main, display: "block", marginTop: 4 }}
            >
              Campanha: {item.campanha}
            </Typography>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
